import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";

import CoursesTable from "./CoursesTable";
import SelectedCourse from "./SelectedCourse";

const Courses = (props) => {
  const [courses, setCourses] = useState(props.courses);
  const [selectedCourse, setSelectedCourse] = useState(props.courses[0]);

  useEffect(() => {
    if (!selectedCourse) return;

    setSelectedCourse(
      courses.find((course) => course.id === selectedCourse.id),
    );
  }, [courses]);

  return (
    <div className="flex flex-start gap-24">
      <CoursesTable
        courses={courses}
        setCourses={setCourses}
        selectedCourse={selectedCourse}
        setSelectedCourse={setSelectedCourse}
      />

      <SelectedCourse
        courses={courses}
        setCourses={setCourses}
        selectedCourse={selectedCourse}
        allUsers={props.allUsers}
        allGroups={props.allGroups}
      />
    </div>
  );
};

Courses.propTypes = {
  courses: PropTypes.array,
  allUsers: PropTypes.array,
  allGroups: PropTypes.array,
};

export default Courses;
